import React, { useState, useEffect } from 'react'
import { Alink } from '../libs/module'
import { Api } from '../libs/api'
import { useLocation } from 'react-router'

const isMainSet = window.isMainDisplay ? -1 : 0

const Lnb = ({ fixMode, activeLnb, isMinishopDetail }) => {
    const [cateList, setCateList] = useState([])
    const [gnbShow, setGnbShow] = useState(false)
    const [isMain] = useState(window.isMainDisplay || false)
    const [isMinishopState, setIsMinishopState] = useState({ isMinishop: false })
    const [depth, setDepth] = useState(isMainSet)
    const [overIndex, setOverIndex] = useState([isMainSet, -1, -1, -1])
    const [cateWidth, setCateWidth] = useState(378)
    const { search } = useLocation()

    const iconObj = {
        '0000000101': 'TV',
        '0000000102': 'computer',
        '0000000103': 'game',
        '0000000104': 'ball',
        '0000000105': 'interior',
        '0000000106': 'kid',
        '0000000107': 'apple',
        '0000000108': 'dress',
        '0000000109': 'lip',
        '0000000110': 'life',
        '0000000111': 'car',
        '0000000112': 'print',
        '0000000113': 'dog',
    }

    useEffect(() => {
        getCategory()
    }, [])

    useEffect(() => {
        setGnbShow(false)

        if (!fixMode && isMain) {
            setDepth(-1)
            setOverIndex([-1, -1, -1, -1])
        } else {
            setDepth(0)
            setOverIndex([0, -1, -1, -1])
        }
    }, [fixMode])

    const getDomain = () => {
        let domainName = window.location.hostname.split('.')[0] // pc, shopping, minishop
        if (process.env.NODE_ENV === 'development') {
            domainName = 'minishop' // 개발 도메인 변경
            if (domainName === 'minishop') {
                return { isMinishop: true, name: 'runcom' }
            } else {
                return { isMinishop: false }
            }
        }
        if (domainName === 'minishop') {
            return { isMinishop: true, name: window.location.pathname.split('/')[1] }
        } else {
            return { isMinishop: false }
        }
    }

    const getCategory = async () => {
        const minishop = getDomain()
        const isMinishop = minishop.isMinishop
        setIsMinishopState(minishop)
        let minishopIdx = 1 // 1: 행복쇼핑

        if (isMinishop) {
            const minishopName = minishop.name
            try {
                const getMinishopIdx = await Api.getMallInfo(minishopName)
                minishopIdx = getMinishopIdx.data.data.manager[0].idx_b_manager
            } catch (e) {
                console.error(e)
            }
        }

        Api.getCategoryV3({ minishopIdx })
            .then(res => {
                if (res.data.success === false) {
                    throw new Error(res.data.message)
                }
                const data = res.data.result.cate
                setCateList(data)
            })
            .catch(e => {
                console.error(e)
            })
    }

    const gnbShowChange = visible => () => {
        if (activeLnb !== 0) {
            if (visible === undefined) {
                setGnbShow(state => !state)
                if (!gnbShow) {
                    gnbReset()
                }
            } else {
                setGnbShow(visible)
                if (!visible) {
                    gnbReset()
                }
            }
        }
    }

    const overMenu = (index, depth, isChild) => () => {
        setDepth(depth)

        const idx = [...overIndex]
        idx[depth] = index
        setOverIndex(idx)

        if (depth < 2) {
            setCateWidth(378)
        } else if (depth === 2) {
            isChild ? setCateWidth(378 + 185) : setCateWidth(378)
        } else if (depth === 3) {
            isChild ? setCateWidth(378 + 185 + 178) : setCateWidth(378 + 185)
        }
    }

    const gnbReset = () => {
        setOverIndex([(!fixMode && isMain) ? -1 : 0, -1, -1, -1])
        setDepth((!fixMode && isMain) ? -1 : 0)
        setCateWidth(378)
    }

    /**
     * activeLnb는 미니샵 도메인일 떄만 존재
     * @returns {string}
     */
    const validateActiveLnb = () => {
        if (activeLnb !== undefined){
            if (activeLnb === 1){
                return 'auto'
            } else {
                return 'none'
            }
        } else {
            return 'auto'
        }
    }

    useEffect(() => {
        if (search.includes('ad_code')) {
            let queryStringAdCode = new URLSearchParams(search).get('ad_code')
            if (queryStringAdCode === 'dap019') {
                setGnbShow(true)
            }
        }
    }, [search])

    let computerCateList = ''
    if(window.isMiniShop || isMinishopDetail){
        computerCateList = cateList.filter((v) => {
            return v.cate_id === "0000000102"
        })
    }

    return (
        <div
            className={`GNavCate ${isMain ? 'is_main' : ''}`}
            onMouseEnter={gnbShowChange(true)}
            onMouseLeave={gnbShowChange(false)}
        >
            <button type="button" className={`GNCAllBtn ${gnbShow ? 'on' : ''}`}
                style={{pointerEvents: validateActiveLnb()}}
            >
                <i className="icon-burger" />
                <span>전체 상품분류</span>
            </button>
            {cateList?.length > 0 && (gnbShow || (!fixMode && isMain)) && (
                <div className="gnb_layer">
                    <div className="cate_main_list">
                        <ul className="cate_main_ul">
                            {(window.isMiniShop || isMinishopDetail) ? (
                                computerCateList.map((v, i) => (
                                    <List
                                        key={i}
                                        index={i}
                                        cate={v}
                                        depth={depth}
                                        overMenu={overMenu}
                                        cateWidth={cateWidth}
                                        overIndex={overIndex}
                                        gnbShowChange={gnbShowChange}
                                        icon={iconObj[v.cate_id]}
                                        isMinishopState={isMinishopState}
                                        search={search}
                                        />
                                        ))
                                ): (
                                cateList.map((v, i) => (
                                    <List
                                        key={i}
                                        index={i}
                                        cate={v}
                                        depth={depth}
                                        overMenu={overMenu}
                                        cateWidth={cateWidth}
                                        overIndex={overIndex}
                                        gnbShowChange={gnbShowChange}
                                        icon={iconObj[v.cate_id]}
                                        isMinishopState={isMinishopState}
                                        search={search}
                                    />
                                ))
                            )}
                        </ul>
                    </div>
                </div>
            )}
        </div>
    )
}

const List = ({
    index,
    cate,
    depth,
    overMenu,
    cateWidth,
    overIndex,
    gnbShowChange,
    icon,
    isMinishopState,
    search,
}) => {
    const baseUrl = isMinishopState.isMinishop
        ? `${process.env.REACT_APP_MINISHOP_URL}/${isMinishopState.name}`
        : process.env.REACT_APP_SHOPPING_URL
    const cateAllLink = `${baseUrl}/list/${cate.cate_id}/all`

    if (search.includes('ad_code')) {
        let queryStringAdCode = new URLSearchParams(search).get('ad_code')
        if (queryStringAdCode === 'dap019') {
            let queryStringAdIdx = new URLSearchParams(search).get('ad_cate')
            if (queryStringAdIdx === cate.cate_id) {
                setTimeout(() => {
                    if (overIndex[0] !== index) {
                        overMenu(index, 0)()
                    }
                }, 1000)
            }
        }
    }

    return (
        <li className="cate_main_li">
            <a href={null} onMouseEnter={overMenu(index, 0)}>
                <i className={`icon-${icon}`} /> <span>{cate.cate_name}</span>
            </a>
            {index === overIndex[0] && depth > -1 && (
                <div className="depth_layer" style={{ width: `${cateWidth + 269}px` }}>
                    <button className="closed" onClick={gnbShowChange(false)}>
                        닫기<i className="icon-close"></i>
                    </button>
                    <div className="cate_field">
                        <div className="top">
                            <div className="title">{cate.cate_name}</div>
                            <Alink href={cateAllLink} className="site_map_btn">
                                전체보기
                            </Alink>
                        </div>
                        <div className="cate_list_field" style={{ width: `${cateWidth}px` }}>
                            <ul className="cate_sub_ul sub1">
                                {cate.child.map((cate1, i1) => (
                                    SubList(i1, cate1, depth, overIndex, overMenu, 0, isMinishopState)
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="banner_field">
                        <iframe src={`${process.env.REACT_APP_AD_URL}/dap019/${cate.cate_id}`} title="adv" />
                    </div>
                </div>
            )}
        </li>
    )
}

const SubList = (index, cate, depth, overIndex, overMenu, cateDepth, isMinishopState) => {
    const host = isMinishopState.isMinishop ? process.env.REACT_APP_MINISHOP_URL : process.env.REACT_APP_SHOPPING_URL
    const baseUrl = isMinishopState.isMinishop ? `${host}/${isMinishopState.name}` : `${host}`
    const target = host === window.location.hostname
        ? cate.f_lnk_new
            ? '_blank'
            : '_self'
        : '_blank'

    const url = cate.f_clk
        ? cate.lnk_url || `${baseUrl}/list/${cate.cate_id}`
        : null
    return (
        <li key={index}>
            <a
                href={url}
                onMouseEnter={overMenu(index, cateDepth+1, cate.child.length)}
                target={target}
                style={{cursor:cate.f_clk === 1 ? 'pointer' : 'default'}}
            >
                {cate.cate_name} {cate?.child?.length > 0 && <i className="icon-angle-right"/>}
            </a>
            {cate?.child?.length > 0 && (
                depth > cateDepth && (index === overIndex[cateDepth+1]) && (
                    <ul className="cate_sub_ul sub2">
                        {cate.child.map((cate2, index2) => (
                            SubList(index2, cate2, depth, overIndex, overMenu, cateDepth+1, isMinishopState)
                        ))}
                    </ul>
                )
            )}
        </li>
    )
}

export default Lnb



// WEBPACK FOOTER //
// ./src/header/component/lnb.js